import { AccountType } from "@ctypes";
import { Translations, i18n } from "@i18n";

import { AccountTypeCardContent } from "./types";

export const accountTypeCardContent: Partial<Record<AccountType, AccountTypeCardContent>> = {
  [AccountType.JuniorRothIra]: {
    title: i18n.t(Translations.AccountTypeRouteJuniorRothIRATitle),
    description: i18n.t(Translations.AccountTypeRouteJuniorRothIRACardDescription),
    strength: i18n.t(Translations.AccountTypeRouteJuniorRothIRAStrength),
    limitation: i18n.t(Translations.AccountTypeRouteJuniorRothIRALimitation),
  },
  [AccountType.CustodialRothIra]: {
    title: i18n.t(Translations.AccountTypeRouteCustodialRothIRATitle),
    description: i18n.t(Translations.AccountTypeRouteCustodialRothIRACardDescription),
    strength: i18n.t(Translations.AccountTypeRouteCustodialRothIRAStrength),
    limitation: i18n.t(Translations.AccountTypeRouteCustodialRothIRALimitation),
  },
  [AccountType.FiveTwoNinePlan]: {
    title: i18n.t(Translations.AccountTypeRoute529PlanTitle),
    description: i18n.t(Translations.AccountTypeRoute529PlanCardDescription),
    strength: i18n.t(Translations.AccountTypeRoute529PlanStrength),
    limitation: i18n.t(Translations.AccountTypeRoute529PlanLimitation),
  },
  [AccountType.GeneralInvesting]: {
    title: i18n.t(Translations.AccountTypeRouteGeneralInvestingTitle),
    description: i18n.t(Translations.AccountTypeRouteGeneralInvestingCardDescription),
    strength: i18n.t(Translations.AccountTypeRouteGeneralInvestingStrength),
    limitation: i18n.t(Translations.AccountTypeRouteGeneralInvestingLimitation),
  },
  [AccountType.RothIra]: {
    title: i18n.t(Translations.AccountTypeRouteRothIRATitle),
    description: i18n.t(Translations.AccountTypeRouteRothIRACardDescription),
    strength: i18n.t(Translations.AccountTypeRouteRothIRAStrength),
    limitation: i18n.t(Translations.AccountTypeRouteRothIRALimitation),
  },
  [AccountType.TraditionalIra]: {
    title: i18n.t(Translations.AccountTypeRouteTraditionalIRATitle),
    description: i18n.t(Translations.AccountTypeRouteTraditionalIRACardDescription),
    strength: i18n.t(Translations.AccountTypeRouteTraditionalIRAStrength),
    limitation: i18n.t(Translations.AccountTypeRouteTraditionalIRALimitation),
  },
  [AccountType.HarvestUtmaUgma]: {
    title: i18n.t(Translations.AccountTypeRouteHarvestUtmaUgmaOption),
    description: i18n.t(Translations.AccountTypeRouteHarvestUtmaUgmaCardDescription),
    strength: i18n.t(Translations.AccountTypeRouteHarvestUtmaUgmaStrength),
    limitation: i18n.t(Translations.AccountTypeRouteHarvestUtmaUgmaLimitation),
  },
  [AccountType.Reserve]: {
    title: i18n.t(Translations.AccountTypeRouteReserveTitle),
    description: i18n.t(Translations.AccountTypeRouteReserveCardDescription),
    strength: i18n.t(Translations.AccountTypeRouteReserveStrength),
    limitation: i18n.t(Translations.AccountTypeRouteReserveLimitation),
  },
};
